import { MapOverlay, MapOverlayCategory } from '../map/map-overlay';
import { Visualizer, VisualizerControl, VisualizationUpdateLevel } from '../data-source/visualizer';
import { Drawer } from '../panel/cabinets';
import { ModelingDataSource } from './modeling';
import { ModelingVisualizerControl, ModelingContainer } from './container-modeling';
import { Timeline } from '../timeline/timeline';
import { MapOverlaySVGContentProducer } from '../map/svg-overlay';
import { ColorMode, CombineMode, RenderMode } from '../worker/scalar-field-manager';
import { Map as TLMDMap } from '../map/map';
import { InspectionPanel } from '../panel/panel';
import { WindFieldLayer, WindProfileInterval } from '@mapp/r-mapp-lib';
import WindFieldWorker from 'worker-loader!../wind-field/wind-field-worker';

export class ModelingMapVisualizer extends MapOverlay implements Visualizer {
	private controls: { [key: string]: ModelingVisualizerControl }
	private inspectionContainer: ModelingContainer
	private source: ModelingDataSource;

	private combineMode: CombineMode
	private renderMode: RenderMode
	private colorMode: ColorMode
	private projectsToRender: string[];

//	private windFieldWorker: Worker;
//	private svelteWindFieldLayer: WindFieldLayer;

	public constructor(private visualizerKey: string, private mdlType: string, private drawer: Drawer, className: string) {
		super(
			MapOverlayCategory.MODELLING_RESULT,
			className,
			{
				elementData: {
					'source': drawer.getContainer().getDataSource().getName(),
					'visualizer': visualizerKey
				}

			},
			new MapOverlaySVGContentProducer()
		)

		this.inspectionContainer = <ModelingContainer>this.drawer.getContainer();
		this.source = this.inspectionContainer.getDataSource();

		let self = this;


//		const windFieldId = this.source.getWindFieldId(this.mdlType);
//		if (windFieldId) {
//			this.windFieldWorker = new WindFieldWorker();
//
//			if (this.inspectionContainer.getContainerNode()) {
//				if ((<InspectionPanel>this.inspectionContainer.getPanel()).getMapImplementationWrapper()) {
//					const svelteWindFieldLayerArgument = {
//						target: this.inspectionContainer.getContainerNode(),
//						props: {
//							worker: this.windFieldWorker,
//							host: <string>undefined, //ussuming same host
//							domain: encodeURI(this.inspectionContainer.getApplication().getDomain()),
//							credentials: this.inspectionContainer.getApplication().getDigester().getCredentials(),
//							legacyMapWrapper: (<InspectionPanel>this.inspectionContainer.getPanel()).getMapImplementationWrapper(),
//							legacyMap: <google.maps.Map>undefined, //will be set by this viewers setMap
//							hpc: windFieldId.hpc,//<string>undefined, //defined by the scalarfield manager
//							model: windFieldId.model,//<string>undefined, //defined by the scalarfield manager
//							profile: <WindProfileInterval[]>[],//defined by the scalarfield manager
//							time: <number>undefined,//defined by time cursor
//							legacyLogging: false, //is also the default, but kept for documentation
//						}
//					}
//
//					this.svelteWindFieldLayer = new WindFieldLayer(svelteWindFieldLayerArgument);
//
//					const updateWindFieldProfile = (profile: WindProfileInterval[]) => {
//						this.svelteWindFieldLayer.$$set({
//							profile,
//						});
//					}
//
//					const updateWindField = (time: number | undefined) => {
//						this.svelteWindFieldLayer.$$set({
//							time,
//						});
//					}
//
//					this.source.getScalarFieldManager(this.mdlType).setWindFieldConsumer(updateWindFieldProfile, updateWindField);
//				}
//			}
//		}


		// listener for svg consumption
		this.source.getScalarFieldManager(this.mdlType).setSVGConsumer((_id, _time, svg, _fresh) => {
			(<MapOverlaySVGContentProducer>this.getProducer()).setSVG(svg);
			self.update();
		});

	}

	public key(): string {
		return this.visualizerKey + '_' + this.type();
	}

	public type(): string {
		return this.mdlType;
	}

	public setControls(controls: { [key: string]: VisualizerControl }): Visualizer {
		this.controls = <{ [key: string]: ModelingVisualizerControl }>controls;
		return this;
	}

	public release(): void {
	}

	public setTimeline(_timeline: Timeline): void {
		//we do not deal with the timeline here
	}

	public updateSelection(): void {
		//not implemented (yet??)
	}

//	public setMap(map: TLMDMap): void {
//		if (this.svelteWindFieldLayer) {
//			this.svelteWindFieldLayer.$$set({
//				legacyMap: map ? map.getGMap() : undefined,
//			});
//		}
//		super.setMap(map);
//	}

	public refresh(_level: VisualizationUpdateLevel): void {
		let combineMode;
		let renderMode;
		let colorMode;
		let projectsToRender;
		if (this.controls && this.controls[this.type()] && this.controls[this.type()].enabled(this.key())) {
			combineMode = this.controls[this.type()].combineMode(this.key());
			renderMode = this.controls[this.type()].renderMode(this.key());
			colorMode = this.controls[this.type()].colorMode(this.key());
			projectsToRender = this.controls[this.type()].projectsToRender();
		} else {

		}

		this.updateMap(_level, combineMode, renderMode, colorMode, projectsToRender);
	}

	public updateMap(level: VisualizationUpdateLevel, combineMode: CombineMode, renderMode: RenderMode, colorMode: ColorMode, projectsToRender: string[]): void {
		this.combineMode = combineMode;
		this.renderMode = renderMode;
		this.colorMode = colorMode;
		this.projectsToRender = projectsToRender;
		//test if we the viewer is active
		if (level != undefined && this.combineMode && this.renderMode && this.colorMode) {
			if (!this.getMap()) {
				this.setMap(this.source.getMap());

			}
			//call scalarfield manager; update will happen asynchroneously using web worker
			this.source.getScalarFieldManager(this.mdlType).setModes(this.combineMode, this.renderMode, this.colorMode, this.projectsToRender);

		} else {
			//visualizer not active 
			this.setMap(null);
		}
	}

	//protected subscribe(){
	//	super.subscribe();
	//	this.addSubscribtion(
	//
	//		this.inspectionContainer.getApplication().getMainMap().getObservable('mousemove').subscribe( ev => {
	//			let lat:number = ev.latLng.lat();
	//			let lng:number = ev.latLng.lng();
	//		console.log(`{ lat:${lat}, lng:${lng} }`); } )
	//		)
	//
	//}
}